<form [formGroup]="housingDataForm" class="row">
  <h3 class="h-sub-section col-12">
    {{ 'app_housing_data_form_title' | translate }}
  </h3>
  <div class="col">
    <div class="input-box">
      <label
        for="postCode"
        [class.has-error]="housingDataForm.controls['postCode'].touched && housingDataForm.controls['postCode'].invalid"
      >
        {{ 'app_housing_data_form_postal_code' | translate }}
      </label>
      <input class="form-control" id="postCode" formControlName="postCode" type="text" placeholder="" maxlength="5" />
      <div class="error-content">
        @if (
          housingDataForm.controls['postCode'].touched && housingDataForm.controls['postCode'].hasError('required')
        ) {
          <p class="has-error">
            {{ 'hipotecas_error_required' | translate }}
          </p>
        }

        @if (housingDataForm.controls['postCode'].touched && housingDataForm.controls['postCode'].hasError('pattern')) {
          <p class="has-error">
            {{ 'hipotecas_error_postal_code' | translate }}
          </p>
        }

        @if (
          housingDataForm.controls['postCode'].touched &&
          housingDataForm.controls['postCode'].hasError('noValidPostalCode')
        ) {
          <p class="has-error">
            {{ 'hipotecas_error_postal_code_unauthorized' | translate }}
          </p>
        }
      </div>
    </div>
  </div>
  <div class="col">
    <div class="input-box">
      <label
        for="squareMeters"
        [class.has-error]="
          housingDataForm.controls['squareMeters'].touched && !housingDataForm.controls['squareMeters'].valid
        "
        >{{ 'app_housing_data_form_square_meters' | translate }}</label
      >
      <input
        appOnlyNumbers
        class="form-control"
        id="squareMeters"
        formControlName="squareMeters"
        type="text"
        placeholder=""
        [maxLength]="HTML_VALIDATORS?.maxLength?.squareMeters"
      />
      <div class="error-content">
        @if (
          housingDataForm.controls['squareMeters'].touched &&
          housingDataForm.controls['squareMeters'].hasError('required')
        ) {
          <p class="has-error">
            {{ 'hipotecas_error_required' | translate }}
          </p>
        }
      </div>
    </div>
  </div>
  <div class="col">
    <div class="input-box">
      <label
        for="signatureDate"
        [class.has-error]="
          housingDataForm.controls['signatureDate'].touched && !housingDataForm.controls['signatureDate'].valid
        "
      >
        {{ 'app_housing_data_form_signature_date' | translate }}
      </label>
      <p-datepicker
        [readonlyInput]="false"
        inputId="signatureDate"
        formControlName="signatureDate"
        dateFormat="dd/mm/yy"
        [monthNavigator]="true"
        readonlyInput="true"
        [minDate]="minDate"
      ></p-datepicker>
      <!-- <input class="form-control" id="signatureDate" formControlName="signatureDate" type="text" placeholder="" /> -->
      <div class="error-content">
        @if (
          housingDataForm.controls['signatureDate'].touched &&
          housingDataForm.controls['signatureDate'].hasError('required')
        ) {
          <p class="has-error">
            {{ 'hipotecas_error_required' | translate }}
          </p>
        }
      </div>
    </div>
  </div>
</form>
